import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PROMOTED_SIGNATURE_RECEIPT_EMAIL_PROMOTION_COUNT = createFcmDetails(
	'promoted_signature_receipt_email_promotion_count',
	{
		owner: 'Site Platform',
		context: 'comms stack',
		import: false,
		description:
			'Defines the number of promoted petitions that should be included in the footer of the signature receipt email',
	},
);
